<section class="section discover-area bg-gray overflow-hidden ptb_100">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-12 col-lg-6 order-2 order-lg-1">
                <!-- Discover Thumb -->
                <div class="service-thumb discover-thumb mx-auto">
                    <img src="assets/img/discover_thumb.png" alt="">
                </div>
            </div>
            <div class="col-12 col-lg-6 order-1 order-lg-2">
                <!-- Discover Text -->
                <div class="discover-text pt-4 pt-lg-0">
                    <h2 class="pb-4 pb-sm-0">Easily communicate with clients using sApp.</h2>
                    <p class="d-none d-sm-block pt-3 pb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique dolor ut iusto vitae autem neque eum ipsam, impedit asperiores vel cumque laborum dicta repellendus inventore voluptatibus et explicabo nobis unde.</p>
                    <!-- Check List -->
                    <ul class="check-list">
                        <li class="py-1">
                            <!-- List Box -->
                            <div class="list-box media">
                                <span class="icon align-self-center"><i class="fas fa-check"></i></span>
                                <span class="media-body pl-2">Combined with a handful of model sentence structures looks reasonable.</span>
                            </div>
                        </li>
                        <li class="py-1">
                            <!-- List Box -->
                            <div class="list-box media">
                                <span class="icon align-self-center"><i class="fas fa-check"></i></span>
                                <span class="media-body pl-2">Contrary to popular belief, Lorem Ipsum is not simply random text.</span>
                            </div>
                        </li>
                        <li class="py-1">
                            <!-- List Box -->
                            <div class="list-box media">
                                <span class="icon align-self-center"><i class="fas fa-check"></i></span>
                                <span class="media-body pl-2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</span>
                            </div>
                        </li>
                        <li class="py-1">
                            <!-- List Box -->
                            <div class="list-box media">
                                <span class="icon align-self-center"><i class="fas fa-check"></i></span>
                                <span class="media-body pl-2">All the Lorem Ipsum generators on the Internet tend to repeat necessary.</span>
                            </div>
                        </li>
                    </ul>
                    <div class="icon-box d-flex mt-3">
                        <div class="service-icon">
                            <span><i class="fas fa-bell"></i></span>
                        </div>
                        <div class="service-icon px-3">
                            <span><i class="fas fa-envelope-open"></i></span>
                        </div>
                        <div class="service-icon">
                            <span><i class="fas fa-video"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>